var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainityNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "30.000001pt",
    viewBox: "0 0 90 30.000001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.09375 6.5625 L 2.96875 6.5625 L 2.96875 -25.375 L 13.09375 -25.375 Z M 5.375 -23.234375 L 5.375 -22.1875 L 7.4375 -22.1875 L 7.4375 -21 L 5.328125 -21 L 5.328125 -19.953125 L 10.625 -19.953125 L 10.625 -21 L 8.53125 -21 L 8.53125 -22.1875 L 10.625 -22.1875 L 10.625 -23.234375 Z M 5.328125 -19.125 L 5.328125 -15.796875 L 10.625 -15.796875 L 10.625 -16.890625 L 8.53125 -16.890625 L 8.53125 -19.125 Z M 7.4375 -16.890625 L 6.390625 -16.890625 L 6.390625 -18.03125 L 7.4375 -18.03125 Z M 5.328125 -14.9375 L 5.328125 -13.890625 L 7.4375 -13.890625 L 7.4375 -12.703125 L 5.328125 -12.703125 L 5.328125 -11.640625 L 8.53125 -11.640625 L 8.53125 -13.890625 L 10.625 -13.890625 L 10.625 -14.9375 Z M 9.578125 -13.015625 L 9.578125 -10.90625 L 5.328125 -10.90625 L 5.328125 -9.828125 L 10.625 -9.828125 L 10.625 -13.015625 Z M 7.4375 -9.125 L 7.4375 -7.328125 L 8.53125 -7.328125 L 8.53125 -8.0625 L 9.578125 -8.0625 L 9.578125 -6.5625 L 6.390625 -6.5625 L 6.390625 -9.125 L 5.328125 -9.125 L 5.328125 -5.515625 L 10.625 -5.515625 L 10.625 -9.125 Z M 5.328125 -3.59375 L 5.328125 0.015625 L 10.625 0.015625 L 10.625 -3.59375 Z M 9.578125 -1.046875 L 6.390625 -1.046875 L 6.390625 -2.546875 L 9.578125 -2.546875 Z M 5.328125 0.75 L 5.328125 1.8125 L 7.5625 1.8125 L 5.328125 3.296875 L 5.328125 4.359375 L 10.625 4.359375 L 10.625 3.296875 L 7.375 3.296875 L 9.609375 1.8125 L 10.625 1.8125 L 10.625 0.75 Z M 5.328125 0.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.203125 -3.234375 C 7.671875 -3.234375 8 -3.25 8.1875 -3.28125 L 8.1875 -0.125 C 7.488281 0.113281 6.710938 0.234375 5.859375 0.234375 C 4.484375 0.234375 3.441406 -0.0859375 2.734375 -0.734375 C 2.023438 -1.390625 1.671875 -2.414062 1.671875 -3.8125 L 1.671875 -9.734375 L 0.171875 -9.734375 L 0.171875 -12.796875 L 1.671875 -12.796875 L 1.671875 -16.015625 L 5.90625 -16.015625 L 5.90625 -12.796875 L 7.984375 -12.796875 L 7.984375 -9.734375 L 5.90625 -9.734375 L 5.90625 -4.46875 C 5.90625 -4.144531 5.941406 -3.894531 6.015625 -3.71875 C 6.097656 -3.539062 6.226562 -3.414062 6.40625 -3.34375 C 6.59375 -3.269531 6.859375 -3.234375 7.203125 -3.234375 Z M 7.203125 -3.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.96875 -13.03125 C 8.425781 -13.03125 8.800781 -12.988281 9.09375 -12.90625 L 9.015625 -8.734375 L 8.6875 -8.765625 C 8.226562 -8.804688 7.890625 -8.828125 7.671875 -8.828125 C 7.046875 -8.828125 6.539062 -8.742188 6.15625 -8.578125 C 5.769531 -8.410156 5.492188 -8.148438 5.328125 -7.796875 L 5.328125 0 L 1.078125 0 L 1.078125 -12.796875 L 5.03125 -12.796875 L 5.171875 -11.109375 C 5.492188 -11.722656 5.890625 -12.195312 6.359375 -12.53125 C 6.835938 -12.863281 7.375 -13.03125 7.96875 -13.03125 Z M 7.96875 -13.03125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.828125 -3.359375 C 11.828125 -2.460938 11.867188 -1.800781 11.953125 -1.375 C 12.035156 -0.945312 12.175781 -0.554688 12.375 -0.203125 L 12.375 0 L 8.140625 0 C 8.003906 -0.320312 7.890625 -0.6875 7.796875 -1.09375 C 7.460938 -0.675781 7.054688 -0.347656 6.578125 -0.109375 C 6.097656 0.117188 5.488281 0.234375 4.75 0.234375 C 3.976562 0.234375 3.257812 0.0703125 2.59375 -0.25 C 1.9375 -0.570312 1.410156 -1.023438 1.015625 -1.609375 C 0.617188 -2.203125 0.421875 -2.875 0.421875 -3.625 C 0.421875 -4.957031 0.914062 -5.988281 1.90625 -6.71875 C 2.894531 -7.445312 4.414062 -7.8125 6.46875 -7.8125 L 7.5625 -7.8125 L 7.5625 -8.40625 C 7.5625 -8.914062 7.453125 -9.304688 7.234375 -9.578125 C 7.023438 -9.847656 6.679688 -9.984375 6.203125 -9.984375 C 5.773438 -9.984375 5.460938 -9.882812 5.265625 -9.6875 C 5.066406 -9.5 4.96875 -9.179688 4.96875 -8.734375 L 0.734375 -8.734375 C 0.734375 -9.578125 0.960938 -10.320312 1.421875 -10.96875 C 1.890625 -11.625 2.550781 -12.128906 3.40625 -12.484375 C 4.269531 -12.847656 5.273438 -13.03125 6.421875 -13.03125 C 7.460938 -13.03125 8.390625 -12.851562 9.203125 -12.5 C 10.023438 -12.15625 10.664062 -11.632812 11.125 -10.9375 C 11.59375 -10.238281 11.828125 -9.390625 11.828125 -8.390625 Z M 5.8125 -2.84375 C 6.226562 -2.84375 6.59375 -2.921875 6.90625 -3.078125 C 7.21875 -3.242188 7.4375 -3.441406 7.5625 -3.671875 L 7.5625 -5.53125 L 6.375 -5.53125 C 5.757812 -5.53125 5.316406 -5.359375 5.046875 -5.015625 C 4.785156 -4.671875 4.65625 -4.265625 4.65625 -3.796875 C 4.65625 -3.515625 4.765625 -3.285156 4.984375 -3.109375 C 5.210938 -2.929688 5.488281 -2.84375 5.8125 -2.84375 Z M 5.8125 -2.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.359375 -18.21875 C 3.804688 -18.21875 4.207031 -18.125 4.5625 -17.9375 C 4.914062 -17.757812 5.191406 -17.507812 5.390625 -17.1875 C 5.597656 -16.863281 5.703125 -16.492188 5.703125 -16.078125 C 5.703125 -15.660156 5.601562 -15.289062 5.40625 -14.96875 C 5.207031 -14.644531 4.925781 -14.390625 4.5625 -14.203125 C 4.207031 -14.023438 3.804688 -13.9375 3.359375 -13.9375 C 2.898438 -13.9375 2.492188 -14.023438 2.140625 -14.203125 C 1.785156 -14.390625 1.503906 -14.644531 1.296875 -14.96875 C 1.097656 -15.289062 1 -15.660156 1 -16.078125 C 1 -16.492188 1.097656 -16.863281 1.296875 -17.1875 C 1.503906 -17.507812 1.785156 -17.757812 2.140625 -17.9375 C 2.492188 -18.125 2.898438 -18.21875 3.359375 -18.21875 Z M 1.25 0 L 1.25 -12.796875 L 5.515625 -12.796875 L 5.515625 0 Z M 1.25 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.703125 -13.03125 C 9.960938 -13.03125 10.941406 -12.632812 11.640625 -11.84375 C 12.347656 -11.0625 12.703125 -9.765625 12.703125 -7.953125 L 12.703125 0 L 8.4375 0 L 8.4375 -7.953125 C 8.4375 -8.410156 8.367188 -8.757812 8.234375 -9 C 8.109375 -9.25 7.925781 -9.414062 7.6875 -9.5 C 7.445312 -9.582031 7.128906 -9.625 6.734375 -9.625 C 6.035156 -9.625 5.523438 -9.390625 5.203125 -8.921875 L 5.203125 0 L 0.953125 0 L 0.953125 -12.796875 L 4.9375 -12.796875 L 5.078125 -11.3125 C 5.503906 -11.875 6.023438 -12.300781 6.640625 -12.59375 C 7.253906 -12.882812 7.941406 -13.03125 8.703125 -13.03125 Z M 8.703125 -13.03125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 12.859375 -12.796875 L 7.71875 1.890625 C 7.519531 2.484375 7.273438 3.007812 6.984375 3.46875 C 6.703125 3.925781 6.269531 4.320312 5.6875 4.65625 C 5.101562 5 4.347656 5.171875 3.421875 5.171875 C 3.035156 5.171875 2.757812 5.15625 2.59375 5.125 C 2.4375 5.101562 2.144531 5.035156 1.71875 4.921875 L 1.71875 1.78125 L 2.234375 1.765625 C 2.804688 1.765625 3.222656 1.691406 3.484375 1.546875 C 3.742188 1.410156 3.929688 1.207031 4.046875 0.9375 L 4.359375 0.171875 L -0.109375 -12.796875 L 4.4375 -12.796875 L 6.328125 -5.96875 L 8.328125 -12.796875 Z M 12.859375 -12.796875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 6.432971,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 14.561039,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 23.646734,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 36.20824,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 42.728449,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 56.188462,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 62.70867,
    y: 22.019293
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(28.62854%,31.369019%,34.118652%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 70.836737,
    y: 22.019293
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainityNav);
export default __webpack_public_path__ + "static/media/trainityNav.ca789bceadbc336ed22febf393b625f4.svg";
export { ForwardRef as ReactComponent };